import { z } from 'zod';

import type { useI18n } from '@change-corgi/core/react/i18n';

type BuildSchemaParams = { translate: ReturnType<typeof useI18n>['translate'] };

export function buildSchema({ translate }: BuildSchemaParams) {
	return z.object({
		issue: z
			.string({ message: translate('corgi.start_a_petition.issue_prompt.error') })
			.min(1, { message: translate('corgi.start_a_petition.issue_prompt.error') }),
		personalStory: z.string().optional().default(''),
	});
}
